<!-- Main Dashboard Container -->
<div class="row">
  <div class="col-xl-12">
    <app-card cardTitle="Dashboard Overview" [options]="false" blockClass="table-border-style">

      <!-- Admin Dashboard (userType == 1) -->
      <div class="row">
        <!-- Home Count -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor' [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Home</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-home f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.homeCount}}
            </h3>
          </app-card>
        </div>

        <!-- Hospital Count -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Hospital</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.hospitalCount}}
            </h3>
          </app-card>
        </div>

        <!-- Total Categories -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/categories')">
            <h6 class="mb-2">Total Categories</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-layers f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalCategories}}
            </h3>
          </app-card>
        </div>

        <!-- Total Wards -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/wards')">
            <h6 class="mb-2">Total Wards</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-grid f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWards}}
            </h3>
          </app-card>
        </div>

        <!-- Total Ward Incharge -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/users')">
            <h6 class="mb-2">Total Ward Incharge</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-user-check f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWardIncharge}}
            </h3>
          </app-card>
        </div>

        <!-- Total Discharged -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Discharged</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-log-out f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalDischarge}}
            </h3>
          </app-card>
        </div>

      </div>

      <!-- Category Wise Table -->
      <div class="row mt-4">
        <div class="col-md-6">
          <h5 class="mb-4">Category Wise</h5>
          <app-card class='cursor'  cardTitle="Category Wise Count" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Category</th>
                    <th> Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let item of dashboardData?.categoriesWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPersons}}</td>
                    <td>

                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span  class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>

        <!-- Ward Wise Count -->
        <div class="col-md-6">
          <h5 class="mb-4">Ward Wise</h5>
          <app-card cardTitle="Ward Wise Count" cardClass="table-card" blockClass="p-0" style="height:300px; overflow-y: auto;">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Ward</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ward of dashboardData?.wardWise; let i=index">
                    <td>{{i+1}}</td>
                    <td>{{ward?.name}}</td>
                    <td>{{ward?.totalPersons}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="ward.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="ward.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span  class="mx-2">{{ward?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

      <!-- Recent People -->
      <div class="row mt-4">
        <div class="col-md-12">
          <h5 class="mb-4">Recent Added People</h5>
          <app-card cardTitle="Recent People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Gender</th>
                    <th>Ward</th>
                    <th>Category</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.recentPeople; let i=index" [routerLink]="['/members']"  class='cursor'>
                    <td>{{i+1}}</td>

                    <td>{{p?.name}}</td>

                    <td>#{{p?.regNo}}</td>

                    <td>
                      {{ p?.gender === 1 ? 'Male' : p?.gender === 2 ? 'Female' : 'Other' }}
                    </td>

                    <td>{{p?.wardId?.name || 'NA'}}</td>

                    <td>{{p?.categoryId?.name}}</td>

                    <td>{{p?.createdAt | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       <!-- if end -->

    </app-card>
  </div>
</div>
